import { RedirectRequest } from '@azure/msal-browser';
import * as React from 'react';

const uninitMsalLoginRequest: RedirectRequest = { scopes: [] };

export const SessionContext = React.createContext({
  showInvalidSession: () => {},
  msalLoginRequest: uninitMsalLoginRequest,
});
